<template>
    <div class="depth">
        <div class="tempFlash"> 
            <div class="personalLnfo">
                <p>姓名：<span>{{$route.query.idName||'-'}}</span></p>
                <p>账号：<span>{{$route.query.idCardNo||'-'}}</span></p>
            </div>
            <div class="flash-title">
                <p class="title-p"><b>进度</b></p>
                <div class="finished">已完成:<b>{{okNum}}</b> </div>
                <div class="finishNo">未完成:<b>{{noNum}}</b></div>
            </div>
            <div class="flash-body leftFlashBody">
                <div class="flash-body-son" ref="flashBodySon">
                    <div class="plaster"
                        v-for="(item,index) in prosecutor"
                        :key="index"
                        @click="flashTag(item)"
                        :style="{
                            background:(item.isCurrent? listStatus[3].color:item.color),
                            color:item.isCurrent? '#fff':'',
                            marginLeft:((flashBodyEleWidth-144)/8+'px'),
                            marginRight:((flashBodyEleWidth-144)/8+'px')
                        }"
                    >{{item.serial}}</div>
                </div>
            </div>
            <div class="flash-fooder">
                <div class="fooder-li" v-for="(item,index) in listStatus" :key="index" :style="{width:(100/listStatus.length)+'%'}">
                    <span :style="{background:(item.color)}"></span>
                    <p>{{item.txt}}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState,mapMutations,mapAction } from 'vuex'
export default {
    props: {
        buttonNum:Number,
    },
    data() {
        return {
            listStatus:[
                {
                    status:1,
                    color:'#66FA98',
                    txt:'已完成'
                },{
                    status:2,
                    color:'#F2F2F2',
                    txt:'未完成'
                },{
                    status:3,
                    color:'#EDBD00',
                    txt:'进行中'
                },{ 
                    status:4,
                    color:'#417DFC',
                    txt:'当前'
                }
            ],
            prosecutor:[],
            jsonDataJudge:[],
            flages:[],
            flashBodyEleWidth:225,
            okNum:0,
            noNum:0,
        }
    },
    computed: {
        ...mapState({
            opcitions: state => state.isZip
        }
    )},
    watch:{
        opcitions: {
            handler (val) {
                this.processTheData(val.zipLoading)
            },
            deep:true
        },
        buttonNum: {
            handler (now,old) {
                this.prosecutor[old-1].isCurrent = false
                this.prosecutor[now-1].isCurrent = true
            },
            deep:true
        },
    },
    mounted(){
        window.addEventListener('resize', () => this.conHeightFun(), false)
    },
    methods:{
        conHeightFun(){
            let dom = this.$refs.flashBodySon;
            this.flashBodyEleWidth = dom.offsetWidth
        },
        passData(data){
            let that = this
            that.prosecutor = []
            data.forEach((element,index) => {
                element.questionList.forEach((ele,i) => {
                    that.prosecutor.push({
                        serial:ele.serial,
                        color:that.listStatus[1].color,
                        isCurrent:index==0&&i==0?true:false,
                    })
                    that.noNum++;
                })
            })
            that.$nextTick(()=>{
                that.conHeightFun()
            })
        },
        artery(jsonDataJudge,flages){
            let that = this
            that.okNum = 0
            that.noNum = 0
            that.jsonDataJudge = jsonDataJudge
            that.flages = flages
            for (let i = 0; i < that.prosecutor.length; i++) {
                if(flages.indexOf(i)!=-1){
                    that.prosecutor[i].color = that.listStatus[1].color;
                    that.noNum++;
                }else{
                    that.prosecutor[i].color = that.listStatus[0].color;
                    that.okNum++;
                }
            }
        },
        processTheData(ing){
            let that = this
            if(JSON.stringify(ing) == "{}"){
                that.$emit('storeLocally')
                return
            }
            for (let i = 0; i < that.jsonDataJudge.length; i++) {
                if(that.jsonDataJudge[i] == '120'){
                    let docProcess = Object.keys(ing).filter((son)=>son.includes(`doc_${i+1}_`))
                    let iDocVal = false
                    for (let di = 0; di < docProcess.length; di++) {
                        if(eval("ing."+docProcess[di]) && eval("ing."+docProcess[di])<100)
                        iDocVal = true
                    }

                    if(iDocVal){
                        that.prosecutor[i].color = that.listStatus[2].color;
                    }else{
                        that.prosecutor[i].color = that.listStatus[2].color;
                        if(that.flages.indexOf(i)!=-1){
                            that.prosecutor[i].color = that.listStatus[1].color;
                        }else{
                            that.prosecutor[i].color = that.listStatus[0].color;
                        }
                    }
                }
            }
        },
        flashTag(item){
            this.$emit('flashTag',item.serial)
        }
    }
}
</script>
<style scoped lang="less">
.depth{
    .tempFlash{
        height: 100%;
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
        padding: 5px;
        position: relative;
        .personalLnfo{
            text-align: left;
            background-color: #EEF0F7;
            border:1px dashed #979DAF;
            box-sizing: border-box;
            padding: 7px 0px 7px 4px;
            border-radius: 3px;
            color: #000;
            font-weight: bold;
            p{
                padding: 0;
                margin: 5px 0;
                span{
                    vertical-align: bottom;
                    font-size: 15px;
                    display: inline-block;
                    max-width: 160px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
        .flash-title{
            position: absolute;
            top: 80px;
            left: 0px;
            width: 100%;
            box-sizing: border-box;
            padding: 5px 0;
            padding-left: 10px;
            .title-p{
                float: left;
                width: 100%;
                font-size: 16px;
                color: #000;
                margin: 10px 0 3px 0px;
                text-align: left;
            }
            .finished{
                float: left;
                width: 50%;
                display: inline-block;
                text-align: left;
                font-size: 13px;
            }
            .finishNo{
                float: right;
                width: 50%;
                display: inline-block;
                text-align: left;
                font-size: 13px;
            }
        }
        .flash-title::after{
            height: 0;
            display: block;
            overflow: hidden;
            content: '';
            clear: both;
        }
        .flash-body{
            position: absolute;
            left: 0;
            top:145px;
            bottom: 50px;
            width: 100%;
            box-sizing: border-box;
            padding: 5px 0;
            overflow-x: hidden;
            overflow-y: auto;
            .flash-body-son{
                width: 100%;
                display: inline-block;
                .plaster{
                    float: left;
                    height: 36px;
                    width: 36px;
                    margin: 8.75px;
                    border-radius: 5px;
                    box-shadow: 1px 1px 2px #888888;
                    border: 1px solid #ccc;
                    box-sizing: border-box;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                }
            }
        }
        .flash-fooder{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 50px;
            box-sizing: border-box;
            padding: 5px 0 0 0;
            border-top: 1px solid #EDEEED;
            .fooder-li{
                float: left;
                height: 100%;
                span{
                    height: 15px;
                    width: 15px;
                    display: inline-block;
                    border-radius: 50%;
                    border: 1px solid #ccc;
                }
                p{
                    margin: 0;
                    text-align: center;
                    font-size: 13px;
                    margin-top: -3px;
                }
            }
        }
    }
}
</style>
<style>
     /* 滚动条样式 */
    .leftFlashBody ::-webkit-scrollbar 
    { 
        width: 5px; 
    }
    
    /*定义滚动条轨道 内阴影+圆角*/
    .leftFlashBody ::-webkit-scrollbar-track 
    { 
        border-radius: 10px; 
        background-color: #00174E; 
    } 
    
    /*定义滑块 内阴影+圆角*/
    .leftFlashBody ::-webkit-scrollbar-thumb 
    { 
        border-radius: 10px; 
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); 
        background-color: #B4B4B4;
    } 
    .flash-body-son .plaster:hover{
        border-color: #84b98a !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/exam/answerSheet.vue